<script setup lang="ts">
import { useReport } from "@/api/report-query";
import CommonHeader from "@/components/common/CommonHeader.vue";
import Frame from "@/components/common/Frame.vue";
import CustomRouterView from "@/layouts/content/CustomRouterView.vue";
import Drawer from "@/layouts/drawer/Drawer.vue";
import DrawerLayout from "@/layouts/drawer/DrawerLayout.vue";
import { DrawerSelection } from "@/layouts/drawer/use-drawer-data";
import { useDrawerStore } from "@/stores";
import { mdiTextBoxMultipleOutline } from "@mdi/js";
import { useScreenSize } from "@soft-db/ui";

const route = useRoute();
const id = computed(() => (route.params.id || "") as string);

const { report } = useReport(id);
const title = computed(() => report.value?.title || "");

const { mdOrLower } = useScreenSize();
const { toggleDrawer } = useDrawerStore();
const router = useRouter();

function changePage(selection: DrawerSelection) {
	router.push({
		name: "reports-id-settings",
		params: { id: selection.id },
		query: { ...route.query },
	});
	if (mdOrLower.value) toggleDrawer();
}
</script>

<template>
	<DrawerLayout>
		<template #drawer>
			<Drawer :objects="['report']" @click="changePage" />
		</template>
		<div class="h-full overflow-auto">
			<nav class="bg-base-200 z-1 sticky top-0 flex items-center gap-2 border-b p-2">
				<CommonHeader :name="title" :icon="mdiTextBoxMultipleOutline" />
			</nav>
			<Frame>
				<CustomRouterView />
			</Frame>
		</div>
	</DrawerLayout>
</template>
